import React from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, CheckCircle, Package } from "lucide-react";
import productsData from "../data/products.json";

const ProductDetails = () => {
  const { category } = useParams();
  const product = productsData[category];

  if (!product)
    return (
      <div className="min-h-screen flex items-center justify-center">
        Product not found
      </div>
    );

  return (
    <section className="relative min-h-screen py-24 md:py-32 bg-gray-50">
      <div className="container relative z-10">
        <Link to="/#products">
          <motion.button
            className="flex items-center gap-2 text-brand-navy hover:text-brand-yellow mb-12 transition-colors font-medium"
            whileHover={{ x: -5 }}
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Products
          </motion.button>
        </Link>

        {/* <motion.div className="mb-12" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold bg-brand-yellow/10 text-brand-yellow mb-4">
            {product.highlight}
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-brand-navy mb-4">{product.title}</h1>
          <p className="text-lg text-gray-600 max-w-3xl">{product.description}</p>
        </motion.div> */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {product.items.map((item, index) => (
            <motion.div
              key={index}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl hover:z-10"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scaleY: 1.05 }}
              layout
            >
              <img
                src={item.image}
                alt={item.name}
                loading="lazy"
                className="w-full h-[28rem] object-cover"
              />
              
              <div className="absolute bottom-0 left-0 right-0 backdrop-blur-md bg-black/40 p-6 transition-all duration-500 group-hover:h-auto">
                <div className="flex flex-col gap-4">
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">
                      {item.name}
                    </h3>
                    <p className="text-white text-sm">{item.description}</p>
                  </div>

                  <div className="max-h-0 group-hover:max-h-96 overflow-hidden transition-all duration-500 delay-100">
                    <h4 className="text-white font-semibold text-sm mb-2">
                      Origin
                    </h4>
                    <p className="text-white/90 text-sm">{item.origin}</p>
                  </div>

                  <div className="max-h-0 group-hover:max-h-96 overflow-hidden transition-all duration-500 delay-200">
                    <h4 className="text-white font-semibold text-sm mb-2">
                      Packaging
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {item.packaging.map((pkg, i) => (
                        <span
                          key={i}
                          className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-white/20 text-white"
                        >
                          <Package className="w-3 h-3" />
                          {pkg}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="max-h-0 group-hover:max-h-96 overflow-hidden transition-all duration-500 delay-300">
                    <h4 className="text-white font-semibold text-sm mb-2">
                      Specifications
                    </h4>
                    <div className="space-y-1">
                      {Object.entries(item.specifications).map(([key, value]) => (
                        <div key={key} className="flex justify-between text-sm">
                          <span className="text-white/80 capitalize">
                            {key.replace(/([A-Z])/g, " $1")}
                          </span>
                          <span className="text-white font-medium">
                            {value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductDetails;
